// Validación de teléfonos en el cliente para "Escribir a repartidor". Es solo
// UX: el backend normaliza y valida de nuevo.

const E164 = /^\+[1-9]\d{7,14}$/;

// Prefijo por defecto SOLO donde el número nacional es inequívoco. Argentina
// (+54) queda fuera: los móviles de WhatsApp llevan un 9 intermedio (+549…) que
// el usuario no escribe de forma natural, y adivinarlo enviaría al número
// equivocado. Ahí se pide el número con "+".
const DEFAULT_DIAL_CODE = { CL: "+56" };

/** Prefijo de marcado por defecto del país del operador, o null si no es fiable. */
export function defaultDialCode(countryCode, countryResolved) {
  if (!countryResolved) return null;
  return DEFAULT_DIAL_CODE[String(countryCode || "").toUpperCase()] || null;
}

export function isE164(value) {
  return E164.test(String(value || ""));
}

/**
 * Arma un E.164 a partir de lo tipeado. Con "+" se respeta; sin "+" se antepone
 * el prefijo por defecto (quitando ceros iniciales). Devuelve null si no se
 * puede formar un E.164 válido.
 */
export function toE164(input, dialCode) {
  const raw = String(input || "").trim();
  if (!raw) return null;
  const digits = raw.replace(/\D/g, "");
  if (raw.startsWith("+")) {
    const candidate = `+${digits}`;
    return isE164(candidate) ? candidate : null;
  }
  if (!dialCode) return null;
  const candidate = `${dialCode}${digits.replace(/^0+/, "")}`;
  return isE164(candidate) ? candidate : null;
}

/** Validación laxa para editar el teléfono registrado (acepta nacional o con +). */
export function isPlausiblePhone(input) {
  const raw = String(input || "").trim();
  if (!/^\+?[\d\s().-]+$/.test(raw)) return false;
  const digits = raw.replace(/\D/g, "").length;
  return digits >= 8 && digits <= 15;
}
